export const REPORT_TYPE = {
  COMPANIES: 'COMPANIES',
  TENDERS: 'TENDERS',
  TENDERS_COMPLETED: 'TENDERS_COMPLETED',
  TENDERS_FAILED: 'TENDERS_FAILED',
};
